import React from 'react'
import { Route } from 'react-router-dom'

import HomeView from "./index";

const HomeViewRoutes = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={props => (
            <HomeView>
                <Component {...props} />
            </HomeView>
        )} />
    )
}

export default HomeViewRoutes
